import * as utils from './utils';
/**
 * Returns the CDN domain host
 * @returns string domain host
 */
export const getCDNHost = (): string => {
    return 'a.sfdcstatic.com';
};

export const getEnv = (): string => {
    const sfdcBase = (window as any).sfdcBase || {};
    return utils.getEnv(sfdcBase);
};

export const getDefaultTbidConfigVersionPerEnv = (): string | undefined => {
    const environmentLabelMapping: Record<string, string> = {
        DEV: 'v1-latest',
        QA: 'v1-latest',
        PERF: 'v1-stable',
        HOTFIX: 'v1-stable',
        UAT: 'v1-stage',
        STAGE: 'v1-stage',
        ONBOARD: 'v1-stable',
        PROD: 'v1-stable',
    };

    const env = getEnv().toUpperCase();

    return environmentLabelMapping[env];
};
